export default {
  title: 'Zamów',
};
